export default __webpack_public_path__ + "static/media/pufferfish.726395ec.png";